import React from 'react';
import * as ReactModal from 'react-modal';

ReactModal.setAppElement('#root');

const stopModalOverlayEvent = event => {
  if (!event) {
    return;
  }

  event.stopPropagation?.();
  event.preventDefault?.();
  event.nativeEvent?.stopImmediatePropagation?.();
};

// Modal content is rendered in a portal. Keep interactions inside it from
// reaching document-level "outside click" listeners in the component that
// opened the modal (for example, an Actions menu).
const stopModalContentEvent = event => {
  if (!event) {
    return;
  }

  event.stopPropagation?.();
  event.nativeEvent?.stopImmediatePropagation?.();
};

const Modal = ({
  isOpen,
  onAfterOpen,
  onRequestClose,
  style = {},
  contentWrapperStyle,
  contentWrapperClassName,
  overlayClassName = 'Overlay',
  contentLabel = 'Example Modal',
  children,
  ...rest
}) => {
  if(!isOpen) return null;

  return (
    <ReactModal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      style={style}
      //className={className || 'Modal'}
      overlayClassName={overlayClassName}
      contentLabel={contentLabel}
      overlayElement={(props, contentElement) => (
        <div
          {...props}
          onClick={event => {
            if (event.target === event.currentTarget) {
              stopModalOverlayEvent(event);
            }
            props.onClick?.(event);
          }}
          onMouseDown={event => {
            if (event.target === event.currentTarget) {
              stopModalOverlayEvent(event);
            }
            props.onMouseDown?.(event);
          }}
        >
          {contentElement}
        </div>
      )}
      {...rest}
    >
      <div
        className={contentWrapperClassName}
        style={contentWrapperStyle}
        onMouseDown={stopModalContentEvent}
        onClick={stopModalContentEvent}
      >
        { children }
      </div>
    </ReactModal>
  );
};

export default Modal;
